import React from 'react';
import { Portal, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { Notification } from '../../hooks/useNotification';

interface NotificationSnackbarProps {
  notification: Notification | null;
  onClose: () => void;
  autoHideDuration?: number;
}

export const NotificationSnackbar = ({ 
  notification, 
  onClose,
  autoHideDuration = 4000,
}: NotificationSnackbarProps) => {
  if (!notification) return null;

  return (
    <Portal>
      <Snackbar
        open={Boolean(notification)}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={onClose}
          severity={notification.severity}
        >
          {notification.message}
        </MuiAlert>
      </Snackbar>
    </Portal>
  );
};
